import { render } from "./WAIS.vue?vue&type=template&id=c8f6ec00&scoped=true"
import script from "./WAIS.vue?vue&type=script&lang=js"
export * from "./WAIS.vue?vue&type=script&lang=js"

import "./WAIS.vue?vue&type=style&index=0&id=c8f6ec00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f6ec00"]])

export default __exports__